export default function formatDateToDDMMYYYY(date) {
  const updateDate = new Date(date);

  return new Intl.DateTimeFormat("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(updateDate);
}
